import React from "react"
import Image from "gatsby-image"
import { Link } from "gatsby"
import { graphql, useStaticQuery } from "gatsby"
import SocialLinks from "../constants/socialLinks"
// ...GatsbyImageSharpFluid

const query = graphql`
{
  file(relativePath: {eq: "rishik1-img.png"}) {
    childImageSharp {
      fluid {
        ...GatsbyImageSharpFluid

      }
    }
  }
} `
const Hero = () => {
const {file :{childImageSharp: {fluid},
},} =useStaticQuery(query)

  return (
  <header className='hero'>
    <div className='section-center hero-center'>
      <article className='hero-info'>
        <div>

        <div className='underline'></div>
        <h2>I'm Rishik Shrivastav</h2>
        <h4>Developer || I make random things using JavaScript</h4>
        <Link to ='/contact' className='btn'>
          contact me
        </Link>
        <SocialLinks/>  
        </div>

      </article>
      <Image fluid={fluid} className='hero-img'></Image>
    </div>

  </header>
  )
}

export default Hero
